import { useQuery } from '@tanstack/react-query';
import { notesService } from '../api/notes.service';
import { NOTE_KEYS } from './queryKeys';

/** Fetches a single note's full content. Disabled while `noteId` is undefined (no note selected). */
export function useNote(noteId: string | undefined) {
  return useQuery({
    queryKey: NOTE_KEYS.detail(noteId ?? ''),
    queryFn: ({ signal }) => notesService.getById(noteId as string, signal),
    staleTime: 60_000,
    enabled: !!noteId,
  });
}
